import { ModifyIdentity } from '@grid/models';
import { DprForecastSubActivity } from '@shared/models/dpr';

export interface DprForecastSubActivityGridData
  extends ModifyIdentity<DprForecastSubActivity> {}
